/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import Main from '../../../components/HOC/Main'
import SkillTypeForm from '../../../components/pages/SkillTypeForm'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/common/Button';
import { selectSelectedSkillType, setSelectedSkillType, toggleCommonDeleteModal, toggleSkillTypeSlide } from '../../../store/slices/common';
import CustomTable from '../../../components/common/CustomTable';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { clearSkillTypeData, deleteSkillType, fetchSkillType, selectSkillTypeData, setSkillTypeData } from '../../../store/slices/api/inner/skillTypeSlice';
import TableAction from '../../../components/TableAction';
import { FaPlus } from 'react-icons/fa';

export default function SkillTypePage() {
  const dispatch = useDispatch();
  const skillTypeData = useSelector(selectSkillTypeData);
  const selectedSkillType = useSelector(selectSelectedSkillType)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchSkillType,
    setValueAction: setSkillTypeData,
    clearValueActionOnError: clearSkillTypeData,
    isForm: false,
    successMessage: false,
  });

  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedSkillType(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedSkillType(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteSkillType,
    isForm: false,
    afterAPICall,
  });
  // delete end
  

  const handleEdit = (data) => {
    dispatch(setSelectedSkillType(data));
    dispatch(toggleSkillTypeSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedSkillType(null));
    dispatch(toggleSkillTypeSlide())
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'skill_type_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"skill type name"
    },
    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, {title: "skill types"}]} handleDelete={() => {handleDelete({ skillTypeId: selectedSkillType.skill_type_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={skillTypeData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Skill Type</Button>} />
      <SkillTypeForm defaultData={selectedSkillType} fetchData={fetchData} />
    </Main>
  )
}
